import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import NavbarLogo from "./JettyEstateLogo.png";
import dropdownImage from "../../assets/realestate/hero.png";


const NAVIGATION = [
  { name: "Properties", path: "/properties" },
  { name: "About Us", path: "/aboutus" },
  { name: "Contact", path: "/contactus" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  return (
    <nav
      className={`fixed w-full z-[100] transition-all duration-500 ${mobileMenuOpen
        ? "py-4 bg-slate-900"
        : scrolled
          ? " bg-primary/70 backdrop-blur-lg shadow-lg"
          : " bg-transparent"
        }`}
    >

      <div className="w-full mx-auto px-2 md:px-2 flex items-center justify-between relative z-[110]">

        {/* Mobile Toggle - Left Side */}
        <div className="md:hidden flex-1 flex justify-start">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`p-2 rounded-lg transition-colors text-secondary hover:bg-white/10`}
          >
            <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} size="lg" />
          </button>
        </div>

        {/* Desktop Left Navigation */}
        <div className="hidden md:flex flex-1 items-center justify-start gap-8 ml-2 lg:ml-8">
          {NAVIGATION.slice(0, 2).map((item) => (
            <div key={item.name} className="group">
              <Link
                to={item.path}
                className={`text-[12px] font-bold uppercase tracking-widest transition-all hover:opacity-80 text-secondary drop-shadow-md py-6 block`}
              >
                {item.name}
              </Link>
              
              {item.name === "Properties" && (
                <div className="absolute top-[100%] left-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 w-full bg-white shadow-2xl overflow-hidden z-[150] flex border-t border-gray-100">
                  <div className="w-1/4 bg-white p-12 flex flex-col gap-6 justify-center pl-20">
                    {[ 'Jettymayfair'].map((subItem) => (
                      <Link 
                        key={subItem} 
                        to={subItem === 'Jettymayfair' ? '/properties/jettymayfair' : '/properties'}
                        className="text-gray-800 text-lg font-semibold hover:text-gray-500 transition-colors"
                      >
                        {subItem}
                      </Link>
                    ))}
                  </div>
                  <div className="w-3/4 h-[500px]">
                    <img 
                      src={dropdownImage} 
                      alt="Properties" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Logo - Center */}
        <div className="flex-[2] md:flex-initial flex items-center justify-center">
          <Link to="/" className="flex items-center gap-2 group">

            <div
              className="flex flex-col leading-tight text-secondary"
            >
              {/* Title */}
              <span className="font-bold tracking-tight text-[14px]">
                JETTY
              </span>

            </div>
            {/* Logo */}
            <div className="flex-shrink-0 transition-transform duration-200 group-hover:scale-105">
              <img
                src={NavbarLogo}
                alt="Logo"
                className="h-[55px] md:h-[70px] w-auto object-contain"
              />
            </div>

            {/* Text Content */}
            <div
              className="flex flex-col leading-tight text-secondary"
            >
              {/* Title */}
              <span className="font-bold tracking-tight text-[14px]">
                ESTATES
              </span>

            </div>
          </Link>
        </div>

        {/* Desktop Right Navigation & Socials */}
        <div className="hidden md:flex flex-1 items-center justify-end gap-8 mr-2 lg:mr-8">
          <Link
            to={NAVIGATION[2].path}
            className={`text-[12px] font-bold uppercase tracking-widest transition-all hover:opacity-80 text-secondary drop-shadow-md`}
          >
            {NAVIGATION[2].name}
          </Link>

          <div className="hidden lg:flex items-center gap-3">
            {[faFacebookF, faInstagram, faTwitter].map((icon, i) => (
              <a key={i} href="#" className="w-8 h-8 flex items-center justify-center rounded-full transition-all hover:bg-secondary hover:text-primary text-secondary bg-white/10">
                <FontAwesomeIcon icon={icon} size="xs" />
              </a>
            ))}
          </div>
        </div>

        {/* Mobile Right Placeholder (Keeps Logo Centered on Mobile) */}
        <div className="md:hidden flex-1"></div>
      </div >

      {/* Mobile Menu Overlay */}
      < div
        className={`fixed inset-0 bg-slate-900 backdrop-blur-xl z-[100] flex flex-col items-center justify-center transition-all duration-500 ${mobileMenuOpen ? "translate-y-0 opacity-100 visible" : "-translate-y-full opacity-0 invisible"
          }`}
      >
        <div className="flex flex-col items-center gap-8 mt-20">
          {NAVIGATION.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="text-2xl font-black text-secondary hover:opacity-80 transition-colors uppercase tracking-tighter"
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div >
    </nav >
  );
};

export default Navbar;
